<template>
	<div>
		<div class="row">
			<div class="col-md-9">
				<div class="input-group">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<router-link class="btn btn-primary btn-block btn-lg mb-3" to="/formeditor/formschedule">{{ $t('new') }}</router-link>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			:cols="[{ key: 'title', heading: $t('name'), size: 12 }]"
			breakpoint="sm"
			type="Table"
			:dataUrl="`${$settings.APIBaseURL}/formschedule/list`"
			dataProperty="results"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectFormschedule"
			@deleteItem="deleteFormschedule"
			ref="infinitescroll"
			idProperty="id"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			search: {
				q: ""
			}
		};
	},
	mounted() {
		this.getFormschedules();
	},
	methods: {
		newSearch() {
			this.getFormschedules();
		},
		getFormschedules() {
			const body = {
				q: this.search.q ? this.search.q : ""
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		selectFormschedule(item) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/formeditor/formschedule/${item.id}`);
		},
		deleteFormschedule(item) {
			this.$cfetch(`${this.$settings.APIBaseURL}/formschedule/deleteitem`, {
				data: {
					id: item.id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$refs.infinitescroll.removeItem(item);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		}
	},
	computed: {}
};
</script>
